import { useState, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { ChevronRight, Menu, X } from "lucide-react"; // icons
import { Loading } from "../components/common/Loading";
import Sidebar from "../components/sidebar/Sidebar";
import { useAuth } from "../hooks/useAuth";

const DashboardLayout = () => {
    const { user, loading } = useAuth();
    const navigate = useNavigate();
    const [sidebarOpen, setSidebarOpen] = useState(false); // 👈 for mobile toggle
    const [collapsed, setCollapsed] = useState(false); // 👈 for desktop collapse

    useEffect(() => {
        if (!loading && !user) navigate("/auth");
    }, [user, loading, navigate]);

    if (loading) return <Loading />;

    return (
        <div className="flex flex-col h-screen overflow-hidden">


            {/* Main Layout */}
            <div className="flex flex-1 overflow-hidden">
                {/* Sidebar */}
                <aside
                    className={`
            fixed md:static z-30 h-full bg-white shadow-sm border-r transition-all duration-300
            ${collapsed ? "w-16" : "w-64"}
            ${sidebarOpen ? "translate-x-0" : "-translate-x-full md:translate-x-0"}
          `}>
                    <Sidebar user={user} collapsed={collapsed} />
                </aside>

                {/* Overlay for mobile */}
                {sidebarOpen && (
                    <div
                        className="fixed inset-0 bg-black/40 z-20 md:hidden"
                        onClick={() => setSidebarOpen(false)}
                    />
                )}

                <main className="flex-1 bg-gray-100 overflow-y-auto relative">

                    {/* Top Navbar */}
                    <div className="flex flex-row gap-4 px-4 py-3 bg-white z-20 shadow-sm">
                        <div className="hidden md:flex justify-start">
                            <button
                                onClick={() => setCollapsed(!collapsed)}
                                className="text-sm text-gray-600 hover:text-gray-900 transition"
                            >
                                {collapsed ? <ChevronRight size={22} /> : <Menu size={22} />}
                            </button>
                        </div>
                        <header className="flex-1 flex items-center justify-between">
                            <div className="flex items-center gap-3">
                                {/* Mobile Menu Button */}
                                <button
                                    onClick={() => setSidebarOpen(!sidebarOpen)}
                                    className="md:hidden p-2 rounded hover:bg-gray-100 transition"
                                >
                                    {sidebarOpen ? <X size={22} /> : <Menu size={22} />}
                                </button>
                                <h1 className="text-xl text-gray-700 shadow-sm">Complaint Tracker</h1>
                            </div>

                            <div className="flex items-center gap-4">
                                <span className="text-gray-700">{user?.name}</span>
                            </div>
                        </header>
                    </div>
                    {/* Main Content */}

                    <div className="p-4">
                        <Outlet />
                    </div>
                </main>
            </div>
        </div>
    );
};

export default DashboardLayout;





